
export enum MembershipRole {
  Administrator = 0x00,
  Employee = 0x01,
  Developer = 0x02,
  Collaborator = 0x03,
}
